import { queryOptions } from '@tanstack/react-query';
import { getProjects, type ProjectsQueryParams } from '@/actions/projects';
import { getAllPages } from '@/utils/fetch/pagination';

const RESOURCE = 'projects' as const;

const projects = {
  byParams: (params: ProjectsQueryParams) =>
    queryOptions({
      queryFn: () => getAllPages(getProjects, params),
      queryKey: [RESOURCE, 'byParams', params] as const,
    }),
};

export { projects, RESOURCE as PROJECTS_QUERY_KEY };
